import { render, staticRenderFns } from "./PrimaryContactDropdown.vue?vue&type=template&id=c367c698&scoped=true&"
import script from "./PrimaryContactDropdown.vue?vue&type=script&lang=js&"
export * from "./PrimaryContactDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryContactDropdown.vue?vue&type=style&index=0&id=c367c698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c367c698",
  null
  
)

export default component.exports